// Which means a forecast counts is a per-site habit: one site predicts its rejects,
// another only its washing. Users were re-ticking the same boxes every time they came
// back to a site, so the choice is remembered against the site id.
//
// localStorage rather than the sessionStorage the plant selection uses (see
// helpers/plants): the plant being consulted is a per-tab thing, but how a site is
// forecast should still be set the way they left it tomorrow morning.
export const FORECAST_MEANS_KEY = 'crateForecastMeans'

// The request parameters behind the Means dropdown, in the order they are offered.
export const MEAN_FLAG_NAMES = ['collect', 'washing', 'repair', 'reject', 'delivery']

function readAll () {
  try {
    const stored = JSON.parse(localStorage.getItem(FORECAST_MEANS_KEY))
    return stored && typeof stored === 'object' ? stored : {}
  } catch (error) {
    return {}
  }
}

// Null for a site nothing was ever saved for, so the caller can leave the flags alone
// instead of reading missing keys as "every mean off".
export function restoreMeanFlags (plantId) {
  if (plantId === null || plantId === undefined) {
    return null
  }
  const saved = readAll()[String(plantId)]
  if (!saved || typeof saved !== 'object') {
    return null
  }
  const flags = {}
  MEAN_FLAG_NAMES.forEach((name) => {
    if (typeof saved[name] === 'boolean') {
      flags[name] = saved[name]
    }
  })
  return Object.keys(flags).length > 0 ? flags : null
}

export function saveMeanFlags (plantId, flags) {
  if (plantId === null || plantId === undefined || !flags) {
    return
  }
  const kept = {}
  MEAN_FLAG_NAMES.forEach((name) => {
    if (typeof flags[name] === 'boolean') {
      kept[name] = flags[name]
    }
  })
  const all = readAll()
  all[String(plantId)] = kept
  try {
    localStorage.setItem(FORECAST_MEANS_KEY, JSON.stringify(all))
  } catch (error) {
    // Storage full, or blocked by the browser. Not worth interrupting a forecast for.
  }
}
